export const PRO = "PRO";
export const PROMOTIONS = "PROMOTIONS";
export const LOCAL_AD = "LOCAL_AD";
export const SPECIAL_BUY_OF_THE_DAY = "SPECIAL_BUY_OF_THE_DAY";

const initialPreferences = () => ({
  PRO: false,
  PROMOTIONS: false,
  LOCAL_AD: false,
  SPECIAL_BUY_OF_THE_DAY: false
});

const initialData = () => [
  {
    key: 0,
    title: "The Home Depot",
    type: PROMOTIONS,
    subText: "Receive communications about exclusive sneak peaks, special offers, services and more from The Home Depot.",
    checked: false,
  },
  {
    key: 1,
    title: "Local Ad",
    type: LOCAL_AD,
    subText: "Sign up to get the Local Ad from your store delivered right to you.",
    checked: false,
  },
  {
    key: 2,
    title: "Pro Communications",
    type: PRO,
    subText: "Pro Communications are designed to help our Pro customers get the job done right.",
    checked: false,
  },
  {
    key: 3,
    title: "Special Buy of the Day",
    type: SPECIAL_BUY_OF_THE_DAY,
    subText: "The name says it all for this email. Stay informed on new savings, daily.",
    checked: false,
  },
];

export const getOptIns = (subscriptions) => {
  let subs = subscriptions || [];
  const data = initialData();
  let optIns = [];
  subs.forEach((sub) => {
    data.forEach((row) => {
      if (row.type === sub.type && sub.status === "Y") {
        optIns.push(row.key)
      }
    })
  })
  return optIns;
};


export const hasPreferences = (preferences) => {
  return preferences && preferences.some((pref) => "Y" === pref.status);
};

export const hasAnyPreferences = (oldPreferences, newPreferences) => {
  return (oldPreferences && oldPreferences.length > 0) || (newPreferences && newPreferences.length > 0);
}

export const setOldPreferencesToOptOut = (oldPreferences) => {
  const preferences = oldPreferences || [];
  return preferences
    .filter(perf => "Y" === perf.status)
    .map(pref => ({
      type: pref.type,
      status: "N",
      optOutReason: "my_account_email_update"
    }))
};

const toPreferenceList = (subscriptions) => {
  const subs = subscriptions ? subscriptions : [];

  const newPreferences = {};

  subs.forEach((sub) => {
    if(sub.status === "Y") {
      newPreferences[sub.type] = true;
    }
  });

  return newPreferences
};

export const initialTableData = (oldSubscriptions, newSubscriptions) => {
  const tableData = initialData();
  const preferences = initialPreferences();

  const oldPreferences = toPreferenceList(oldSubscriptions);
  const newPreferences = toPreferenceList(newSubscriptions);

  const updatedPreferences = {
    ...preferences,
    ...oldPreferences,
    ...newPreferences
  }

  return tableData.map((row) => {
    return {
      ...row,
      checked: updatedPreferences[row.type]
    }
  })
};

export const convertTableDataToSubscriptions = (selectedItems, tableData) =>  {
  const subscriptions = [];
  selectedItems.forEach((item) => {
    subscriptions.push({
      type: tableData[item].type,
      status: (tableData[item].checked) ? "Y" : "N"
    });
  })
  return subscriptions;
}